import { queryOptions } from "@tanstack/react-query";
import { GeneratedAudioService } from "../service/GeneratedAudioService";

const generatedAudioQueries = {
  all: (spaceId?: string) =>
    queryOptions({
      queryKey: spaceId
        ? ["generated-audio", spaceId]
        : ["generated-audio"],
      queryFn: () => GeneratedAudioService.getAll({ spaceId }),
    }),
};

export { generatedAudioQueries };
